import { useEffect, useState, Fragment } from "react";
// @mui
import {
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Avatar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import axios from "axios";
import moment from "moment";
import { tooltipClasses } from "@mui/material/Tooltip";
import { useNavigate, useSearchParams } from "react-router-dom";
import Iconify from "../iconify";
import AssetsDialog from "./AssetsDialog";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TEAMS } from "src/constants/teams";
// ----------------------------------------------------------------------

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, paddingTop: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const InputTooltip = ({ imgPath }) => (
  <HtmlTooltip
    title={
      <Fragment>
        <img src={imgPath} alt="login" />
      </Fragment>
    }
  >
    <Iconify icon="eva:info-outline" sx={{}} />
  </HtmlTooltip>
);
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const defaultState = {
  title: "",
  prize_image_en: null,
  league_type: "CUSTOM",
};
export default function LeagueDialog(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [league, setLeague] = useState(defaultState);
  const [assetsTarget, setAssetsTarget] = useState(null);
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    if (props.league !== null) {
      setLeague(props.league);
    }
    axios
      .get(
        `${process.env.REACT_APP_CLIENTS_API_BASE_URL}/clients/${process.env.REACT_APP_CLIENT_CODE}/tenants`
      )
      .then((response) => {
        if (response.data?.tenants) {
          setTenants(response.data.tenants);
        }
      });
  }, [props]);
  const handleChange = (e) => {
    const { id, value } = e.target;

    setLeague((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLeague(defaultState);
    props.onSuccessHandler(league);
  };
  const onCancel = () => {
    setLeague(defaultState);
    props.onClose();
  };
  const onChoseAsset = (assetUrl) => {
    setLeague((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };
  const handleChangetype = (event) => {
    setLeague((prevState) => ({
      ...prevState,
      league_type: event.target.value,
    }));
  };

  const handleChangeTeamId = (event) => {
    setLeague((prevState) => ({
      ...prevState,
      league_team_id: event.target.value,
    }));
  };
  const handleChangeTenant = (event) => {
    setLeague((prevState) => ({
      ...prevState,
      tenant: event.target.value,
    }));
  };
  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Create Custom League
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="title"
                  label="Title"
                  fullWidth
                  value={league.title}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              {!props.isSearch && (
                <>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel id="type-select-label">Type</InputLabel>
                      <Select
                        labelId="type-label"
                        id="type-select"
                        value={league.league_type ?? "CUSTOM"}
                        label="Type"
                        onChange={handleChangetype}
                      >
                        <MenuItem value="CUSTOM">CUSTOM BET99</MenuItem>
                        <MenuItem value="CUSTOM_CLUB">CLUB</MenuItem>
                        <MenuItem value="CUSTOM_LEAGUE">LEAGUE</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel id="type-select-label">
                        League Team
                      </InputLabel>
                      <Select
                        labelId="type-label"
                        id="type-select"
                        value={league.league_team_id ?? 1}
                        label="Type"
                        onChange={handleChangeTeamId}
                      >
                        {TEAMS.map((team) => (
                          <MenuItem value={team.teamId}>
                            {team.teamName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="type-select-label">Tenant</InputLabel>
                      <Select
                        labelId="type-label"
                        id="type-select"
                        value={league.tenant ?? ""}
                        label="Tenant"
                        onChange={handleChangeTenant}
                      >
                        {tenants.map((tenant) => (
                          <MenuItem value={tenant.prefix}>
                            {tenant.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              )}
              <Grid item xs={6}>
                <Box>Image</Box>
                {league.league_image_en ? (
                  <>
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Remy Sharp"
                      src={league.league_image_en}
                    />
                    <Iconify
                      icon="eva:edit-outline"
                      sx={{ width: 20, height: 20, cursor: "pointer" }}
                      onClick={() => setAssetsTarget("league_image_en")}
                    />
                  </>
                ) : (
                  <Iconify
                    icon="eva:plus-circle-outline"
                    sx={{
                      width: 20,
                      height: 20,
                      cursor: "pointer",
                      marginTop: 2,
                      marginBottom: 2,
                    }}
                    onClick={() => setAssetsTarget("league_image_en")}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                <Box>Image Fr</Box>
                {league.league_image_fr ? (
                  <>
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Remy Sharp"
                      src={league.league_image_fr}
                    />
                    <Iconify
                      icon="eva:edit-outline"
                      sx={{ width: 20, height: 20, cursor: "pointer" }}
                      onClick={() => setAssetsTarget("league_image_fr")}
                    />
                  </>
                ) : (
                  <Iconify
                    icon="eva:plus-circle-outline"
                    sx={{
                      width: 20,
                      height: 20,
                      cursor: "pointer",
                      marginTop: 2,
                      marginBottom: 2,
                    }}
                    onClick={() => setAssetsTarget("league_image_fr")}
                  />
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button
              onClick={() => onSuccess()}
              autoFocus
              disabled={!league.title || !league.league_image_en}
            >
              {props.league === null ? "Create" : "Edit"}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
}
